import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { db } from "../../lib/firebaseCompat";

import { useAuth } from "../../hooks/usehooks.com/use-auth";
import { useOrganization } from "../../hooks/useOrganization";

export default function AdminOnly({ children }) {
  const { user } = useAuth();
  const { current: org } = useOrganization();
  const [isAdmin, setIsAdmin] = useState(false);

  const uid = user?.uid;
  const orgId = org?.id;

  // @TODO look into memoizing this further
  useEffect(() => {
    if (!uid || !orgId) return;

    const doc = db
      .collection("organizations")
      .doc(orgId)
      .collection("members")
      .doc(uid);
    (async () => {
      try {
        const snapshot = await doc.get();
        const { role } = snapshot.data();
        setIsAdmin(role === "admin");
      } catch {
        setIsAdmin(false);
      }
    })();
  }, [orgId, uid]);

  return isAdmin ? children : null;
}

AdminOnly.propTypes = {
  children: PropTypes.node,
};
